import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpinstance } from "../../axios/api";

// Async thunk for fetching customer admin list
export const fetchCustomerAdminList = createAsyncThunk(
  "fetchCustomerAdminList",
  async (queryParams) => {
    try {
      const url = `/org/list_org_user${queryParams}`;
      const response = await httpinstance.get(url);
      return response.data;
    } catch (err) {
      throw err.response;
    }
  }
);

// Async thunk for creating a new customer admin
export const createCustomerAdmin = createAsyncThunk(
  "createCustomerAdmin",
  async (data) => {
    try {
      const url = `/org/create_org_user`;
      const response = await httpinstance.post(url, data);
      return response.data;
    } catch (err) {
      console.log(err);
      return err.response.data;
    }
  }
);

export const UpdateCustomerAdmin = createAsyncThunk(
  "UpdateCustomerAdmin",
  async (data) => {
    try {
      const url = `org/update_org_user`;
      const response = await httpinstance.post(url, data);
      return response.data;
    } catch (err) {
      throw err.response;
    }
  }
);
export const DeleteCustomerAdmin = createAsyncThunk(
  "DeleteCustomerAdmin",
  async (data) => {
    try {
      const url = `/org/change_user_status`;
      const response = await httpinstance.post(url, data);
      return response.data;
    } catch (err) {
      throw err.response;
    }
  }
);
// Initial state
const initialState = {
  adminList: [],
  isAdminCreated: false,
  createResponse: {},
  updateResponse: {},
  deleteResponse: {},
};

// Slice
const customerAdminSlice = createSlice({
  name: "customerAdmin",
  initialState,
  reducers: {
    setAdminCreated(state, action) {
      state.isAdminCreated = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerAdminList.fulfilled, (state, { payload }) => {
        state.adminList = payload;
      })
      .addCase(fetchCustomerAdminList.rejected, (state, action) => {
        console.error("Failed to fetch customer admin list", action.error);
      })
      .addCase(createCustomerAdmin.fulfilled, (state, { payload }) => {
        state.createResponse = payload;
      })
      .addCase(createCustomerAdmin.rejected, (state, action) => {
        console.error("Failed to create customer admin",action.payload);
      })
      .addCase(UpdateCustomerAdmin.fulfilled, (state, { payload }) => {
        state.updateResponse = payload;
      })
      .addCase(UpdateCustomerAdmin.rejected, (state, action) => {
        console.error("Failed to UPDATE customer admin", action);
      })
      .addCase(DeleteCustomerAdmin.fulfilled, (state, { payload }) => {
        state.deleteResponse = payload;
      })
      .addCase(DeleteCustomerAdmin.rejected, (state, action) => {
        console.error("Failed to DELETE customer admin", action);
      });
  },
});

// Export actions and reducer
export const { setAdminCreated } = customerAdminSlice.actions;
export default customerAdminSlice.reducer;
